import React from 'react';
import {
  Money20Regular,
  CreditCardClock20Regular,
  BuildingBank20Regular,
  DocumentText20Regular,
} from '@fluentui/react-icons';

// Shared payment-method icon picker. Used by both the per-row list in
// OrderRightSidebar and the gateway line in PaymentRowHoverCard so the
// same `payment_method`/label maps to the same glyph in both places.
//
// Accepts either the raw `payment_method` value (e.g. "credit_card",
// "bank_transfer") or the resolved staff-facing label (e.g. "Card",
// "Bank transfer") — both are normalised here.
const PaymentMethodIcon: React.FC<{ method: string | null | undefined; className?: string }> = ({
  method,
  className,
}) => {
  const m = (method || '').toLowerCase().trim();
  if (m === 'card' || m === 'credit_card' || m === 'credit card') {
    return <CreditCardClock20Regular className={className} />;
  }
  if (m === 'ach' || m === 'bank_transfer' || m === 'bank transfer' || m === 'bank') {
    return <BuildingBank20Regular className={className} />;
  }
  if (m === 'check' || m === 'cheque') {
    return <DocumentText20Regular className={className} />;
  }
  // cash + unknown fall through to Money — matches existing row-list fallback.
  return <Money20Regular className={className} />;
};

export default PaymentMethodIcon;
